export const FETCH_INFO_USER_PROFILE_START = '[Profile] Get info user profile start';
export const FETCH_INFO_USER_PROFILE_SUCCESS = '[Profile] Get info user profile success';
export const FETCH_INFO_USER_PROFILE_FAILED = '[Profile] Get info user profile failed';
